module.exports = __webpack_public_path__ + "static/media/projectsImage9.ba028d77.jpg";